<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'statementsDetail',
    components: {
      baseEdit,
    },
  };
</script>
